<template>
  <div class="subscription_page">
    <h1>推广成本导入</h1>
    <div class="user-options clearfix">
      <span>日期：</span>
      <el-date-picker
        v-model="adConst.queryDate"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>
      <span>时区：</span>
      <el-input
        type="text"
        v-model.trim="adConst.timeZone"
        style="width: 150px"
      ></el-input>
      <span>渠道：</span>
      <el-select v-model="adConst.channel" placeholder="请选择" clearable filterable>
        <el-option
          v-for="(item, ind) in channelList"
          :key="ind"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span>平台：</span>
      <el-select v-model="adConst.medium" placeholder="请选择" clearable>
        <el-option
          v-for="(item, ind) in mediumList"
          :key="ind"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span>成本：</span>
      <el-input
        type="text"
        v-model.trim="adConst.adCostMoney"
        style="width: 150px"
      ></el-input>
      <span>Campaign：</span>
      <el-input
        type="text"
        v-model.trim="adConst.campaign"
        style="width: 150px"
      ></el-input>

      <el-button type="warning" @click="add" v-loading="loading1">导入</el-button>

      <el-upload
        class="avatar-uploader"
        action=""
        :auto-upload="false"
        :show-file-list="false"
        :on-change="addExcel"
        ref="upload"
      >
        <el-button type="danger" v-loading="loading2">导入excel</el-button>
      </el-upload>

      <el-button type="primary" @click="query(0)" v-loading="loading"> 刷新 </el-button>
      <el-button type="success" @click="query(1)" v-loading="loading">
        仅看自己
      </el-button>
    </div>
    <div class="display-type">
      <el-table :data="tableList" v-loading="loading">
        <el-table-column prop="date" label="日期" sortable> </el-table-column>
        <el-table-column prop="timeZone" label="时区"> </el-table-column>
        <el-table-column prop="channel" label="渠道"> </el-table-column>
        <el-table-column prop="medium" label="推广平台"> </el-table-column>
        <el-table-column prop="adCostMoney" label="成本" sortable> </el-table-column>
        <el-table-column prop="campaign" label="Campaign"> </el-table-column>
        <el-table-column prop="createDate" label="导入时间" sortable> </el-table-column>
        <el-table-column prop="operator" label="操作人"> </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="del(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrent"
        :current-page.sync="pageInfo.page"
        :page-size="pageInfo.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pageInfo.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableList: [],
      adConst: {
        queryDate: "",
        channel: "",
        medium: "",
        adCostMoney: "",
        timeZone: "",
        campaign: "",
      },
      pageInfo: { page: 1, pageSize: 30, total: 0 },
      channelList: [],
      mediumList: ["google", "facebook", "tiktok", "ASA", "bigo","ASO"],
      loading: false,
      loading1: false,
      loading2: false,
      searchMyself: 0,
    };
  },
  beforeCreate() {},
  created() {
    this.query();
    this.channel_query();
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username;
    },
    token() {
      return this.$store.getters.token;
    },
  },
  watch: {},
  methods: {
    query(val) {
      if (val === 1 || val === 0) {
        this.searchMyself = val;
      }
      this.loading = true;
      this.$axios({
        type: "GET",
        url: this.$store.getters.path.ad_cost_query,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          page: this.pageInfo.page,
          searchMyself: this.searchMyself,
          ...this.adConst,
        },
      })
        .then(
          (res) => {
            this.loading = false;
            if (res.data.code === 0) {
              this.tableList = res.data.data.data;
              this.pageInfo.total = res.data.data.total;
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              this.$router.push(this.$route.query.redirect || "/login");
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          },
          (err) => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: "请求错误:" + err,
              type: "error",
            });
          }
        )
        .then(() => {
          this.loading = false;
        });
    },
    channel_query() {
      this.$axios({
        type: "GET",
        url: this.$store.getters.path.ad_cost_channel,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
        },
      })
        .then(
          (res) => {
            if (res.data.code === 0) {
              this.channelList = res.data.data.data;
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              this.$router.push(this.$route.query.redirect || "/login");
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          },
          (err) => {
            this.loading = false;
            this.$message({
              showClose: true,
              message: "请求错误:" + err,
              type: "error",
            });
          }
        )
        .then(() => {
          this.loading = false;
        });
    },
    add() {
      this.loading1 = true;
      this.$axios({
        type: "GET",
        url: this.$store.getters.path.ad_cost_import_data,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          date: this.adConst.queryDate,
          channel: this.adConst.channel,
          medium: this.adConst.medium,
          adCostMoney: this.adConst.adCostMoney,
          timeZone: this.adConst.timeZone,
          campaign: this.adConst.campaign,
        },
      })
        .then(
          (res) => {
            this.loading1 = false;
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.adConst = {
                queryDate: "",
                channel: "",
                medium: "",
                adCostMoney: "",
                timeZone: "",
                campaign: "",
              };
              this.query();
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              this.$router.push(this.$route.query.redirect || "/login");
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          },
          (err) => {
            this.loading1 = false;
            this.$message({
              showClose: true,
              message: "请求错误:" + err,
              type: "error",
            });
          }
        )
        .then(() => {
          this.loading = false;
        });
    },
    del(id) {
      this.$axios({
        type: "GET",
        url: this.$store.getters.path.ad_cost_del,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          id: id,
        },
      })
        .then(
          (res) => {
            this.loading1 = false;
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });

              this.query();
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              this.$router.push(this.$route.query.redirect || "/login");
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          },
          (err) => {
            this.loading1 = false;
            this.$message({
              showClose: true,
              message: "请求错误:" + err,
              type: "error",
            });
          }
        )
        .then(() => {
          this.loading = false;
        });
    },
    addExcel(file) {
      this.$confirm("确认批量上传此文件", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading2 = true;
          const formdata = new FormData();
          formdata.append("file", file.raw);
          const { data: res } = await this.$axios.post(
            this.$store.getters.path.ad_cost_excel_import_data +
              "?username=" +
              this.$store.getters.username +
              "&token=" +
              this.$store.getters.token,
            formdata
          );
          this.loading2 = false;
          this.query();
          this.$refs.upload.clearFiles();
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          } else {
            this.$message({
              showClose: true,
              message: "操作成功",
              type: "success",
            });
          }
        })
        .catch(() => {
          this.$refs.upload.clearFiles();
        });
    },
    handleCurrent(val) {
      this.pageInfo.page = val;
      this.query();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.subscription_page {
	margin-left: 20px;
	margin-top: 20px;

	h1 {
		font-size: 28px;
		font-weight: bold;
	}

	.user-options {
		margin-top: 30px;
		display: flex;
		align-content: center;
		line-height: 40px;
		flex-wrap: wrap;
    .el-input{
      width: 200px
    }
    ::v-deep .el-select>.el-input{
      width: 200px
    }

		>* {
			margin: 3px 5px;
		}
	}

	.display-type {
		margin-top: 20px;
	}
}
</style>
